import React, { useState, useEffect } from 'react';
import { LogOut, ChevronDown, ChevronUp } from 'lucide-react';
import api from '../services/api';

const CATEGORY_LABELS = {
  integrity: 'Integrity', compassion: 'Compassion', assurance: 'Assurance',
  respect: 'Respect', innovation: 'Innovation'
};

function MahasiswaRiwayatPage({ user, onLogout, onBack }) {
  const [assessments, setAssessments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [expandedId, setExpandedId] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const res = await api.getMyAssessments();
        setAssessments(res.data || []);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <div className="main-content">
      <header className="app-header">
        <div className="header-container">
          <div className="header-left">
            <div className="header-logo">I-CARE</div>
            <div><h1 className="header-title">Riwayat Nilai</h1><p className="header-subtitle">{user.name}</p></div>
          </div>
          <div style={{display:'flex',gap:'0.5rem'}}>
            <button onClick={onBack} className="btn-secondary">Kembali ke Penilaian</button>
            <button onClick={onLogout} className="btn-logout"><LogOut size={16}/><span>Logout</span></button>
          </div>
        </div>
      </header>
      <div className="content-container">
        <div className="card">
          {loading && <p>Memuat...</p>}
          {!loading && assessments.length === 0 && <p>Belum ada riwayat penilaian.</p>}
          {!loading && assessments.length > 0 && (
            <table className="data-table">
              <thead>
                <tr><th>Mata Kuliah</th><th>Periode</th><th>Tipe</th><th>Skor</th><th>Level</th><th></th></tr>
              </thead>
              <tbody>
                {assessments.map(a => (
                  <React.Fragment key={a.id}>
                    <tr onClick={() => setExpandedId(expandedId === a.id ? null : a.id)} style={{cursor:'pointer'}}>
                      <td>{a.course_code} - {a.course_name}</td>
                      <td>{a.period_name}</td>
                      <td>{a.form_type === 'kelas' ? 'Kelas' : 'Praktik'}</td>
                      <td>{a.percentage}%</td>
                      <td>Level {a.level}</td>
                      <td>{expandedId === a.id ? <ChevronUp size={16}/> : <ChevronDown size={16}/>}</td>
                    </tr>
                    {expandedId === a.id && (
                      <tr>
                        <td colSpan={6}>
                          <div style={{display:'flex',flexWrap:'wrap',gap:'1rem',padding:'0.5rem 0'}}>
                            {Object.keys(CATEGORY_LABELS).map(cat => (
                              a.section_scores && a.section_scores[cat] ? (
                                <div key={cat} style={{minWidth:'140px'}}>
                                  <strong>{CATEGORY_LABELS[cat]}</strong>
                                  <div>{a.section_scores[cat].percentage}%</div>
                                </div>
                              ) : null
                            ))}
                          </div>
                        </td>
                      </tr>
                    )}
                  </React.Fragment>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
}

export default MahasiswaRiwayatPage;
